export function buildTitle(item) {
    const name     = Array.isArray(item.name) ? item.name.join(' & ') : (item.name ?? '');
    const parallel = item.cardParallelName ?? 'Base';
    const num      = item.cardNumber ? `#${item.cardNumber} ` : '';
    if (item.cardPrintNumber != null && item.cardSupply != null)
        return `${num}${name} ${parallel} #${item.cardPrintNumber}/${item.cardSupply}`;
    if (item.cardSupply != null)
        return `${num}${name} ${parallel} /${item.cardSupply}`;
    return `${num}${name} ${parallel}`;
}

export function buildSingleDescription(item) {
    return item.series
        ? `${item.series}; Ungraded near mint or better`
        : 'Ungraded near mint or better';
}

/**
 * Groups cards by series in lot order, then builds:
 *   {series}
 *   {buildTitle(card)}
 *   ...
 * Cards without a series omit the header for that block.
 */
export function buildLotDescription(cards) {
    if (!cards?.length) return '';

    const groups = [];
    for (const card of cards) {
        const seriesKey = card.series || null;
        const last = groups[groups.length - 1];
        if (last && last.seriesKey === seriesKey) {
            last.cards.push(card);
        } else {
            groups.push({ seriesKey, cards: [card] });
        }
    }

    return groups
        .map(({ seriesKey, cards: groupCards }) => {
            const lines = [];
            if (seriesKey) lines.push(seriesKey);
            groupCards.forEach((card) => lines.push(buildTitle(card)));
            return lines.join('\n');
        })
        .join('\n\n');
}

export function isLotItem(item) {
    return item?.type === 'lot';
}

export function isSingleItem(item) {
    return !item?.type || item.type === 'single';
}

export function stripCardForLot(item) {
    return {
        cardNumber:       item.cardNumber ?? null,
        name:             item.name ?? [],
        team:             item.team ?? [],
        cardAttributes:   item.cardAttributes ?? [],
        cardParallelName: item.cardParallelName ?? null,
        cardColor:        item.cardColor ?? null,
        cardPrintNumber:  item.cardPrintNumber ?? null,
        cardSupply:       item.cardSupply ?? null,
        sport:            item.sport ?? null,
        year:             item.year ?? null,
        manufacturer:     item.manufacturer ?? null,
        series:           item.series ?? null,
        cardType:         item.cardType ?? null,
        cardTypeCategory: item.cardTypeCategory ?? null,
    };
}
